import modular from 'stereomodularjs';
import * as modules from './modules';
import globals from './globals';
import { html } from './utils/environment';
import './utils/events';
import Cookies from 'js-cookie'

const app = new modular({
    modules: modules
});

window.onload = (event) => {
    const $style = document.getElementById('main-css');
    classAdd(document.querySelector('body'), 't-' + document.querySelector('.js-anims').getAttribute('data-namespace'))

    if ($style) {
        if ($style.isLoaded){
            init();
        } else {
            $style.addEventListener('load', (event) => {
                init();
            });
        }
    } else {
        console.warn('The "main-css" stylesheet not found');
    }

    let isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    window.isMobile = isMobile;

    if(window.isMobile) {
        html.classList.add('is-mobile');
    }
    
    // Add class on gravity medium select container
    let isFirefox = /firefox|fxios/i.test(navigator.userAgent);
    window.isFirefox = isFirefox;
    if(window.isFirefox){
        console.log('is-firefox');
        if(document.querySelector('.gfield_select') && document.querySelector('.gfield_select').closest('.ginput_container_select')){
            document.querySelector('.medium.gfield_select').closest('.ginput_container_select').classList.add('is-medium-container');
        }
        if(document.querySelector('.gfield_select') && document.querySelector('.gfield_select').closest('.ginput_container_select')){
            document.querySelector('.small.gfield_select').closest('.ginput_container_select').classList.add('is-small-container');
        }
    }
    
};

function init() {
    globals();

    app.init(app);

    setTimeout(() => {
        html.classList.add('is-first-loaded');

        let preventChilds = document.querySelectorAll('.js-prevent-childs a');
        preventChilds.forEach(el => {
            el.classList.add('js-prevent');
        });

    }, 50);

    setTimeout(() => {
        html.classList.add('is-loaded');
        html.classList.add('dom-is-loaded');
        html.classList.remove('is-loading');

        //Set CSS4 variable for innerHeight
        function setDocHeight() {
            document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`);
            document.documentElement.style.setProperty('--hw', `${(document.querySelector('.c-header__wrap').offsetHeight) / 100}px`);
        };
        window.addEventListener('resize', function () {
            setDocHeight();
        });
        window.addEventListener('orientationchange', function () {
            setDocHeight();
        });
        setDocHeight();
    }, 300);

    if (document.querySelector('.js-overlay-content-popup') && !Cookies.get(document.querySelector('.js-overlay-content-popup').dataset.cookie)) {
        console.log('show popup')
        setTimeout(() => {
            document.querySelector('.js-nl-popup').$trigger('click');
            document.querySelector('html').classList.add('is-overlay-nl-active');
        },2000);
    }
}
